import { client, mapError } from './client';
import { appConfig } from '../config/app-config';

export interface AddReceiptRequest {
  readonly manualPurchaseOrderId: string;
  readonly mpoNumber: string;
  readonly imageBase64: string;
  readonly storeNumber: string;
}

function addReceipt(req: AddReceiptRequest): Promise<any> {
  return client(
    `upload-receipt`,
    {
      method: 'POST',
      body: req,
    },
    appConfig.apiUrls.micro,
    true
  ).catch(mapError);
}

export { addReceipt };
